module.exports = __webpack_public_path__ + "img/775df0c.png";